<template>
    <component :is="tag" v-if="wrap" :class="wrapperClassName">
        <input
            :class="inputClassName"
            type="radio"
            v-model="inputValue"
            :id="id"
            :name="name"
            v-bind="attrs" />
        <label v-if="label" :class="labelClassName" :for="id">
            {{ label }}
        </label>
    </component>
    <input
        v-if="!wrap"
        :class="inputClassName"
        type="radio"
        v-model="inputValue"
        :id="id"
        :name="name"
        v-bind="attrs" />
    <label v-if="!wrap && label" :class="labelClassName" :for="id">
        {{ label }}
    </label>
</template>

<script>
import { computed } from "vue";

export default {
    name: "RadioInput",
    props: {
        id: String,
        name: String,
        label: String,
        inline: Boolean,
        modelValue: String,
        wrapperClass: String,
        labelClass: String,
        btnCheck: Boolean,
        wrap: {
            type: Boolean,
            default: true
        },
        formCheck: {
            type: Boolean,
            default: true
        },
        tag: {
            type: String,
            default: "div"
        }
    },
    emits: ["update:modelValue"],
    setup(props, { attrs, emit }) {
        const inputValue = computed({
            get: () => props.modelValue,
            set: (value) => emit('update:modelValue', value)
        })

        const wrapperClassName = computed(() => {
            return [
                props.formCheck && !props.btnCheck && "form-check",
                props.inline && "form-check-inline"
            ];
        });

        const inputClassName = computed(() => {
            return [
                props.btnCheck ? "btn-check" : "form-check-input"
            ];
        });

        const labelClassName = computed(() => {
            return [
                props.labelClass || "form-check-label"
            ];
        });

        return {
            inputValue,
            wrapperClassName,
            inputClassName,
            labelClassName,
            attrs,
            props
        };
    }
};
</script>
